export const en = {
  "Search for products...": "Search for products...",
  "Best Sellers": "Best Sellers",
  "Shopping cart": "Shopping cart",
  "My cart": "My cart",
  "Remove all products": "Remove all products",
  "Wishlist": "Wishlist",
  "Compare products": "Compare products",
  "You have not added any products to your wishlist. Add one right now!": "You have not added any products to your wishlist. Add one right now!",
  "You have not added any products to the comparison list. Add one right now!": "You have not added any products to the comparison list. Add one right now!",
  "Add to cart": "Add to cart",
  "Checkout": "Checkout",
  "Quick checkout": "Quick checkout",
  "Go to cart": "Go to cart",
  "Back to shopping": "Back to shopping",
  "Home": "Home",
  "Price": "Price",
  "Remove": "Remove",
  "Sort by": "Sort by",
  "Popular": "Popular",
  "Price ascending": "Price ascending",
  "Price descending": "Price descending",
  "Brand A-Z": "Brand A-Z",
  "Brand Z-A": "Brand Z-A",
  "Name A-Z": "Name A-Z",
  "Name Z-A": "Name Z-A",
  "Newest": "Newest",
  "See more": "See more",
  "Latest products": "Latest products",
  "Results for": "Results for",
  "No products found": "No products found",
  "No brands found": "No brands found",
  "Product not found": "Product not found",
  "Cart update failed": "Cart update failed",
  "Enter the promotional code": "Enter the promotional code",
  "Invalid voucher code": "The code entered is incorrect or not valid for this order",
  "You cannot use your own influencer voucher": "You cannot use your own influencer voucher",
  "Voucher applied successfully": "The promotional code was applied to your cart.",
  "Copy checkout link": "Copy checkout link",
  "Link copied": "Link copied",
  "Discount": "Discount",
  "Subtotal": "Subtotal",
  "Total": "Total",
  "Total (VAT incl.)": "Total (VAT incl.)",
  "Voucher": "Voucher",
  "Voucher not applicable": "You do not have products in your cart to apply the added voucher discount!",
  "Use new address only": "Enter a new delivery address",
  "Use saved addresses": "Use saved addresses",
  "Trade register no.": "Trade register no.",
  "Loading products...": "Loading products...",
  "Your cart is empty": "Your cart is empty",
  "Sign in to add items to your cart.": "Sign in to add items to your cart.",
  "Free Delivery": "Free Delivery",
  "Add another": "Add another",
  "to your shopping bag to get FREE DELIVERY!": "to your shopping bag to get FREE DELIVERY!",
  "Congratulations, you get FREE DELIVERY for this order!": "Congratulations, you get FREE DELIVERY for this order!",
  "Congratulations, free shipping!": "Congratulations, free shipping!",
  "All rights reserved.": "All rights reserved.",
  "Your name": "Your name",
  "Your e-mail address": "Your e-mail address",
  "Subscribe": "Subscribe",
  "Payment & Delivery": "Payment & Delivery",
  "Terms & Conditions": "Terms & Conditions",
  "Privacy Policy": "Privacy Policy",
  "Return Policy": "Return Policy",
  "Bucharest": "Bucharest",
  "Special promotions": "Special promotions",
  "On a monthly basis": "On a monthly basis",
  "Secure payment": "Secure payment",
  "With credit / debit card": "With credit / debit card",
  "Free delivery": "Free delivery",
  "For orders above 100 Lei": "For orders above 100 Lei",
  "We are here for you": "We are here for you",
  "Special Promotions On a monthly basis": "Special Promotions On a monthly basis",
  "Secure Payment With credit / debit card": "Secure Payment With credit / debit card",
  "Free Delivery For orders above 100 Lei": "Free Delivery For orders above 100 Lei",
  "Contact Us Anytime, we are here for you": "Contact Us Anytime, we are here for you",
  "Log out": "Log out",
  "Account": "Account",
  "Buy now": "Buy now",
  "EAN": "EAN",
  "Your order": "Your order",
  "Your order has been successfully registered!": "Your order has been successfully registered!",
  "You can check the status of the order by accessing": "You can check the status of the order by accessing",
  "your account": "your account",
  "or following your e-mail address.": "or following your e-mail address.",
  "Guest order confirmation hint": "You will receive order updates at the e-mail address you provided.",
  "Sign in to see price": "Sign in to see price",
  "Billing information": "Billing information",
  "Name and surname": "Name and surname",
  "Phone number": "Phone number",
  "E-mail address": "E-mail address",
  "Individual": "Individual",
  "Company": "Company",
  "Company name": "Company name",
  "VAT Number": "VAT Number",
  "Office address": "Office address",
  "Bank": "Bank",
  "Bank account": "Bank account",
  "Delivery information": "Delivery information",
  "Saved addresses": "Saved addresses",
  "Saved companies": "Saved companies",
  "New company": "New company",
  "New address": "New address",
  "Address (street, number)": "Address (street, number)",
  "County": "County",
  "City": "City",
  "Zip code": "Zip code",
  "Payment method": "Payment method",
  "Cash on delivery": "Cash on delivery",
  "Credit / Debit card": "Credit / Debit card",
  "Leave a message": "Leave a message",
  "Shipping": "Shipping",
  "Free": "Free",
  "I agree with": "I agree with",
  "the terms and conditions": "the terms and conditions",
  "Please accept the terms and conditions": "Please accept the terms and conditions",
  "Please select a payment method": "Please select a payment method",
  "This field is required": "This field is required",
  "Please enter a valid e-mail address": "Please enter a valid e-mail address",
  "Please select an option": "Please select an option",
  "Please attach a file": "Please attach a file",
  "Order is processing...": "Order is processing...",
  "Back": "Back",
  "Send order": "Send order",
  "Place order": "Place order",
  "Order summary": "Order summary",
  "Shipping address": "Shipping address",
  "Shipping methods": "Shipping methods",
  "Home delivery": "Home delivery",
  "Quantity label": "Qty.",
  "Coupon code": "Coupon code",
  "Check address to continue": "Check your address details to continue",
  "Card payment secure hint": "You will complete card payment securely on the next step.",
  "Checkout trust secure": "Secure SSL payment",
  "Checkout trust returns": "30 days free returns",
  "Checkout trust local": "Romanian company",
  "Order failed": "Order failed",
  "Please wait, we are redirecting you to the secure payment page...": "Please wait, we are redirecting you to the secure payment page...",
  "We will redirect you to the contact page in": "We will redirect you to the contact page in",
  "seconds": "seconds",
  "Order payment": "Order payment",
  "Payment for the order": "Payment for the order",
  "it was done successfully!": "it was done successfully!",
  "We will contact you as soon as possible to confirm the order.": "We will contact you as soon as possible to confirm the order.",
  "it was not done successfully!": "it was not done successfully!",
  "Please contact us to fix this issue.": "Please contact us to fix this issue.",
  "Contact us": "Contact us",
  "Payment is being processed!": "Payment is being processed!",
  "Thank you, payment for the order": "Thank you, payment for the order",
  "is in processing.": "is in processing.",
  "Member since": "Member since",
  "Orders": "Orders",
  "Returns": "Returns",
  "Profile": "Profile",
  "Your network": "Your network",
  "Influencer": "Influencer",
  "Addresses": "Addresses",
  "Notifications": "Notifications",
  "Influencer dashboard": "Influencer dashboard",
  "Influencer access is not enabled for this account.": "Influencer access is not enabled for this account.",
  "Create codes, track commissions, and request payouts.": "Create codes, track commissions, and request payouts.",
  "Pick categories or brands with the same commission percent.": "Pick categories or brands with the same commission percent.",
  "Codes you generated for your audience.": "Codes you generated for your audience.",
  "Orders that earned you commission.": "Orders that earned you commission.",
  "Search categories and brands...": "Search categories and brands...",
  "Search brands...": "Search brands...",
  "Expand to pick subcategories": "Expand to pick subcategories",
  "Browse or search brands": "Browse or search brands",
  "Selection summary": "Selection summary",
  "You chose": "You chose",
  "brand": "brand",
  "category": "category",
  "no brands": "no brands",
  "no categories": "no categories",
  "offering": "offering",
  "discount": "discount",
  "Select categories and/or brands below, then generate your voucher.": "Select categories and/or brands below, then generate your voucher.",
  "No matching scopes": "No matching scopes",
  "scopes selected": "scopes selected",
  "Other": "Other",
  "Categories": "Categories",
  "No influencer vouchers yet": "No influencer vouchers yet",
  "Voucher code": "Voucher code",
  "Commission": "Commission",
  "Validity": "Validity",
  "Applies to": "Applies to",
  "from": "from",
  "to": "to",
  "days remaining": "days remaining",
  "1 day remaining": "1 day remaining",
  "Expired": "Expired",
  "scope": "scope",
  "scopes": "scopes",
  "days": "days",
  "Total generated": "Total generated",
  "Available for payout": "Available for payout",
  "Pending payout": "Pending payout",
  "Paid out": "Paid out",
  "Generate influencer voucher": "Generate influencer voucher",
  "Validity (days)": "Validity (days)",
  "You can only combine scopes with the same percent. For a different percent, generate a separate voucher.": "You can only combine scopes with the same percent. For a different percent, generate a separate voucher.",
  "Request payout": "Request payout",
  "Payment details (IBAN, etc.)": "Payment details (IBAN, etc.)",
  "Your influencer vouchers": "Your influencer vouchers",
  "Commission orders": "Commission orders",
  "No influencer earnings yet": "No influencer earnings yet",
  "Select scopes": "Select scopes",
  "You have not placed any orders on our site yet.": "You have not placed any orders on our site yet.",
  "Order": "Order",
  "Pay with Credit / Debit Card": "Pay with Credit / Debit Card",
  "Download order": "Download order",
  "Return this order": "Return this order",
  "Order information": "Order information",
  "Online payment": "Online payment",
  "Address": "Address",
  "Products": "Products",
  "You have not placed any return requests on our site yet.": "You have not placed any return requests on our site yet.",
  "Return": "Return",
  "Return information": "Return information",
  "Order date": "Order date",
  "Return motive": "Return motive",
  "Bank details": "Bank details",
  "The desired solution": "The desired solution",
  "Saved!": "Saved!",
  "Saving...": "Saving...",
  "Copied!": "Copied!",
  "Copy code": "Copy code",
  "Save": "Save",
  "Change account password.": "Change account password.",
  "New password": "New password",
  "Retype the new password": "Retype the new password",
  "The two passwords are different.": "The two passwords are different.",
  "Change": "Change",
  "Enjoy a": "Enjoy a",
  "commission on every order generated by your network": "commission on every order generated by your network",
  "Your access code for your network": "Your access code for your network",
  "Your comission": "Your comission",
  "Registration date": "Registration date",
  "Unlock the full potential of your network by expanding your connections!": "Unlock the full potential of your network by expanding your connections!",
  "Your benefits": "Your benefits",
  "Generate voucher": "Generate voucher",
  "Voucher code:": "Voucher code:",
  "Value": "Value",
  "Valability": "Valability",
  "Used / Expired": "Used / Expired",
  "Add the delivery and billing addresses. When placing a new order, you will be able to select one of these addresses.": "Add the delivery and billing addresses. When placing a new order, you will be able to select one of these addresses.",
  "Address name (for future use)": "Address name (for future use)",
  "Choose county": "Choose county",
  "Add the new address": "Add the new address",
  "Save modifications": "Save modifications",
  "Edit address": "Edit address",
  "Edit company": "Edit company",
  "Personal information": "Personal information",
  "Password & security": "Password & security",
  "Show password": "Show password",
  "Hide password": "Hide password",
  "Weak password": "Weak password",
  "Fair password": "Fair password",
  "Good password": "Good password",
  "Strong password": "Strong password",
  "Add company": "Add company",
  "No saved addresses yet": "No saved addresses yet",
  "No billing companies yet": "No billing companies yet",
  "Delete this company": "Delete this company",
  "Delete this address": "Delete this address",
  "Close": "Close",
  "You have not set any stock alerts.": "You have not set any stock alerts.",
  "Out of stock": "Out of stock",
  "Work program": "Work program",
  "Monday-Friday, between 9.00 and 17.30 (except for public holidays)": "Monday-Friday, between 9.00 and 17.30 (except for public holidays)",
  "Name": "Name",
  "Message": "Message",
  "Message was sent!": "Message was sent!",
  "Send": "Send",
  "Send failed": "Send failed",
  "Product return form": "Product return form",
  "I want to return the order in full or in parts": "I want to return the order in full or in parts",
  "I would like to return the following products": "I would like to return the following products",
  "The reason for the return is": "The reason for the return is",
  "My return options are": "My return options are",
  "I want to replace the product with a new one": "I want to replace the product with a new one",
  "I want to replace it with another product": "I want to replace it with another product",
  "I want to receive cash value": "I want to receive cash value",
  "Images with the product (s)": "Images with the product (s)",
  "I agree to this notification form regarding my withdrawal from the contract": "I agree to this notification form regarding my withdrawal from the contract",
  "Please accept the terms": "Please accept the terms",
  "Select at least one product": "Select at least one product",
  "Brands": "Brands",
  "Discover premium brands": "Discover premium brands",
  "Fresh picks by category": "Fresh picks by category",
  "Top sellers by category": "Top sellers by category",
  "categories": "categories",
  "products in stock": "products in stock",
  "View products": "View products",
  "Newsletter unsubscribe": "Newsletter unsubscribe",
  "You have been successfully unsubscribed from our newsletter.": "You have been successfully unsubscribed from our newsletter.",
  "Unsubscribe could not be completed.": "Unsubscribe could not be completed.",
  "Please contact us for assistance.": "Please contact us for assistance.",
  "Subscribed successfully!": "Subscribed successfully!",
  "Notify me when back in stock": "Notify me when back in stock",
  "Notify me": "Notify me",
  "Notification saved": "Notification saved",
  "General": "General",
  "Payments": "Payments",
  "Delivery": "Delivery",
  "Support": "Support",
  "More products": "More products",
  "LIMITED TIME DISCOUNTS": "LIMITED TIME DISCOUNTS",
  "See all": "See all",
  "products": "products",
  "brands": "brands",
  "FILTER PRODUCTS": "FILTER PRODUCTS",
  "Filter": "Filter",
  "Clear filters": "Clear filters",
  "CATEGORIES": "CATEGORIES",
  "Departments": "Departments",
  "Main navigation": "Main navigation",
  "Carousel navigation": "Carousel navigation",
  "Search departments categories...": "Search in Beauty categories...",
  "Beauty hub link": "Explore Beauty hub",
  "Search categories...": "Search categories...",
  "No categories found": "No categories found",
  "Search for brand...": "Search for brand...",
  "PRICE": "PRICE",
  "Price range": "Price range",
  "Min": "Min",
  "Max": "Max",
  "Apply price": "Apply",
  "Load more": "Load more",
  "Load more products": "Load more products",
  "View more": "View more",
  "View less": "View less",
  "All products": "All products",
  "The page you are looking for was not found": "The page you are looking for was not found",
  "Campaign": "Campaign",
  "Campaign page is not available yet.": "Campaign page is not available yet.",
  "FAQ": "FAQ",
  "FAQ page subtitle": "Answers to the most common questions about orders, delivery and returns.",
  "Still have questions?": "Still have questions?",
  "FAQ contact hint": "Our team is happy to help you personally.",
  "Use voucher": "Use voucher",
  "Log in": "Log in",
  "Create account": "Create account",
  "Invite code": "Invite code",
  "First name": "First name",
  "Last name": "Last name",
  "Phone": "Phone",
  "Password": "Password",
  "With regards from": "With regards from",
  "Please fill in the details required and prepare yourself for an amazing shopping experience!": "Please fill in the details required and prepare yourself for an amazing shopping experience!",
  "The code used is not valid!": "The code used is not valid!",
  "Login failed": "Login failed",
  "Registration failed": "Registration failed",
  "Network size": "Network size",
  "Network total orders": "Network total orders",
  "Total revenue": "Total revenue",
  "Total vouchers": "Total vouchers",
  "Unclaimed revenue": "Unclaimed revenue",
  "New products": "New products",
  "Free shipping": "Free shipping",
  "Recover password": "Recover password",
  "Welcome back": "Welcome back",
  "New here": "New here",
  "Sign in to continue shopping": "Sign in to continue shopping",
  "Enter your email and captcha to receive a new password.": "Enter your email and captcha to receive a new password.",
  "Reset password": "Reset password",
  "The sum of": "The sum of",
  "The result is...": "The result is...",
  "The new password has been sent by e-mail!": "The new password has been sent by e-mail!",
  "Wrong email address!": "Wrong email address!",
  "Review the product": "Review the product",
  "Your review": "Your review",
  "There are no reviews for this product yet. You can be the first!": "There are no reviews for this product yet. You can be the first!",
  "The review has been sent!": "The review has been sent!",
  "The result is incorrect.": "The result is incorrect.",
  "Send review": "Send review",
  "Phone (optional)": "Phone (optional)",
  "Cancel notification": "Cancel notification",
  "Billing companies": "Billing companies",
  "The company has been successfully added.": "The company has been successfully added.",
  "Delete member": "Delete member",
  "Stars": "Stars",
  "Reviews": "Reviews",
  "Description": "Description",
  "How to use": "How to use",
  "Brand": "Brand",
  "Category": "Category",
  "Gender": "Gender",
  "Size": "Size",
  "Product details": "Product details",
  "in cart": "in cart",
  "Added to cart": "Added to cart",
  "Unit price": "Unit price",
  "Line total": "Line total",
  "Cart total": "Cart total",
  "Qty": "Qty",
  "Incorrect captcha": "Incorrect captcha",
  "The product has been added to cart": "The product has been added to cart",
  "This site uses cookies. By continuing to browse this site, you agree to the use of cookies.": "This site uses cookies. By continuing to browse this site, you agree to the use of cookies.",
  "More details...": "More details...",
  "Discounts": "Discounts",
  "New": "New",
  "Menu": "Menu",
  "Special order request": "Special order request",
  "Product name": "Product name",
  "Product code": "Product code",
  "Request sent!": "Request sent!",
  "View all results": "View all results",
  "Suggested categories": "Suggested categories",
  "Start typing to search": "Start typing to search brands, categories or products",
  "Recent searches": "Recent searches",
  "Leave search for category?": "Leave search for category?",
  "You are about to leave search and open the category page. Continue?": "You are about to leave search and open the category page. Continue?",
  "Open category page": "Open category page",
  "Cancel": "Cancel",
  "Clear category filter": "Clear category filter",
  "Subcategory": "Subcategory",
  "Sub-subcategory": "Sub-subcategory",
  "Sub-sub-subcategory": "Sub-sub-subcategory",
  "Close search": "Close search",
  "Previous": "Previous",
  "Next": "Next",
  "Back to top": "Back to top",
  "Search results": "Search results",
  "Back to orders": "Back to orders",
  "View order details": "View order details",
  "Compare": "Compare",
  "In comparison": "In comparison",
  "Price alert": "Price alert",
  "About the brand:": "About the brand:",
  "Product variants": "Product variants",
  "Delivery & Returns": "Delivery & Returns",
  "Search product variants...": "Search product variants...",
  "Show all": "Show all",
  "Recommended products": "Recommended products",
  "RECENTLY VIEWED": "RECENTLY VIEWED",
  "More from": "More from",
  "Professional Salon Supply": "Professional Salon Supply",
  "Duty Free Supply": "Duty Free Supply",
  "Premium Brands": "Premium brands",
  "Over 20 000 products": "20,000+ curated products",
  "Genuine products": "Authentic products",
  "Traceable official sources": "Verified official sources",
  "Our Support": "Our Support",
  "Standard delivery": "Standard delivery",
  "Delivery in Romania": "Delivery in Romania",
  "from 14.90 lei": "from 14.90 lei",
  "Free shipping title": "Free shipping",
  "over 100 lei": "over 100 lei",
  "Need help?": "Need help?",
  "Call now": "Call now",
  "Footer concierge": "Concierge",
  "Footer store": "Store",
  "Footer account": "Account",
  "Footer information": "Information",
  "Footer tagline": "Premium beauty, wellness & lifestyle",
  "Footer newsletter title": "Exclusive offers and special promotions",
  "Footer newsletter subtitle": "Subscribe for member-only discounts, new arrivals and surprise campaigns — straight to your inbox.",
  "Footer newsletter placeholder": "your@email.com",
  "Footer newsletter cta": "Get exclusive offers",
  "Footer newsletter disclaimer": "By subscribing, you agree to receive commercial communications and our",
  "Footer newsletter promo title": "Fast delivery",
  "Footer newsletter promo text": "Free from 100 lei",
  "Footer value free shipping": "Free shipping over 100 lei",
  "Footer value products": "20,000+ curated products",
  "Footer value trusted": "European & trusted brands",
  "Footer value secure payment": "Secure payment",
  "Footer about heading": "About CorporatesClub",
  "Footer info heading": "Information & contact",
  "Footer shops heading": "Store",
  "Footer brand description": "CorporatesClub is a premium B2B2C shop for beauty, wellness and lifestyle — exclusive member pricing and fast delivery across Romania.",
  "Footer customer service": "Customer service",
  "Email already subscribed": "This email is already subscribed",
  "Payment methods": "Payment methods",
  "SameDay estimated delivery": "SameDay estimated delivery",
  "Estimated delivery": "Estimated delivery",
  "Expected delivery": "Expected delivery",
  "Available": "Available",
  "Special offer": "Special offer",
  "Characteristics": "Characteristics",
  "Delivery and returns": "Delivery and returns",
  "REF": "REF",
  "Coming soon...": "Coming soon...",
  "Fast delivery": "Fast delivery",
  "B2B discounts": "B2B discounts",
  "Exclusive prices for members": "Exclusive prices for members",
  "Welcome to CorporatesClub": "Welcome to CorporatesClub",
  "Discover premium beauty and wellness products for your company, with exclusive B2B discounts and fast delivery across Romania.": "Discover premium beauty and wellness products for your company, with exclusive B2B discounts and fast delivery across Romania.",
  "Why shop with CorporatesClub": "Why shop with CorporatesClub",
  "All categories": "All categories",
  "Card or cash on delivery": "Card or cash on delivery",
  "Estimated delivery on every product": "Estimated delivery on every product",
  "SameDay": "SameDay",
  "Free returns": "Free returns",
  "30 days, risk-free": "30 days, risk-free",
  "Free shipping over 100 lei": "Free shipping over 100 lei",
  "For orders <br /> above 100 lei": "For orders <br /> above 100 lei",
  "This product is a tester and it might be shipped unboxed.": "This product is a tester and it might be shipped unboxed.",
  "Stock notification": "Stock notification",
  "You have an active stock notification for this product!": "You have an active stock notification for this product!",
  "Be the first to find out when it returns to stock!": "Be the first to find out when it returns to stock!",
  "<b>30 days</b> free return": "<b>30 days</b> free return",
  "The product has been added to cart!": "The product has been added to cart!",
  "Click here to go to your shopping cart": "Click here to go to your shopping cart",
  "ALERTA DE PRET": "PRICE ALERT",
  "Set price alert": "Set price alert",
  "I want to be notified if the price drops below": "I want to be notified if the price drops below",
  "Lei": "Lei",
  "You save": "You save",
  "SKU": "SKU",
  "ID #": "ID",
  "I also want to subscribe to the newsletter": "I also want to subscribe to the newsletter",
  "Current product price is": "Current product price is",
  "Language": "Language",
  "Currency": "Currency",
  "EUR": "EUR",
  "Carousel hero promo eyebrow": "Limited time",
  "Carousel hero promo title": "Special Offers",
  "Carousel hero promo subtitle": "Exclusive B2B discounts on top beauty and wellness brands — save on every order",
  "Carousel hero promo cta": "View promotions",
  "Carousel hero delivery eyebrow": "Fast shipping",
  "Carousel hero delivery title": "Quick Delivery",
  "Carousel hero delivery subtitle": "SameDay and nationwide shipping across Romania — free delivery on eligible orders",
  "Carousel hero delivery cta": "Free shipping info",
  "Carousel hero brands eyebrow": "Trusted brands",
  "Carousel hero brands title": "100% Authentic Products",
  "Carousel hero brands subtitle": "Premium brands from official sources — over 20,000 products",
  "Carousel hero brands cta": "Explore brands",
  "Home departments title": "Shop by department",
  "Home departments subtitle": "Start with Beauty today — more departments coming soon to CorporatesClub",
  "Home department beauty title": "Beauty",
  "Home department beauty description": "Fragrance, makeup, skincare, hair care and more — everything in one place",
  "Home department beauty card description": "Perfumes, fragrances, makeup, bath products and more. Discover our full beauty range.",
  "Home department fashion card description": "Apparel and accessories for teams and corporate gifting — launching soon.",
  "Home department home card description": "Home decor, kitchen and lifestyle essentials for modern workplaces.",
  "Home department electronics card description": "Tech gadgets and electronics for business and employee perks.",
  "Home department sports card description": "Sports gear and active lifestyle products for your team.",
  "Home department food card description": "Gourmet food and beverages for corporate events and gifts.",
  "Home department baby card description": "Baby care and kids products for family-friendly benefits.",
  "Home department pets card description": "Pet care essentials for employees who love their companions.",
  "Home department office card description": "Office supplies and workspace essentials for every company.",
  "Home department automotive card description": "Automotive accessories and car care products.",
  "Home department garden card description": "Garden and outdoor living products for green spaces.",
  "Beauty hub intro": "Your dedicated destination for premium beauty and wellness — authentic brands, B2B pricing and fast delivery across Romania.",
  "Beauty hub categories title": "Browse beauty categories",
  "Department hub all departments": "All departments",
  "Department hub current": "Current",
  "Home department fashion title": "Fashion",
  "Home department home title": "Home & Living",
  "Home department electronics title": "Electronics",
  "Home department sports title": "Sports",
  "Home department food title": "Food & Gourmet",
  "Home department baby title": "Baby & Kids",
  "Home department pets title": "Pet Care",
  "Home department office title": "Office",
  "Home department automotive title": "Automotive",
  "Home department garden title": "Garden & Outdoor",
  "Home departments coming soon": "Coming soon",
  "Home department view cta": "View department",
  "Home promo tabs title": "Why CorporatesClub",
  "Home promo tabs tab store": "A multi-department store with tens of thousands of products",
  "Home promo tabs tab delivery": "Fast delivery straight from stock",
  "Home promo tabs tab quality": "Guaranteed quality, every time",
  "Home promo tabs body store": "CorporatesClub brings premium fragrance, makeup and skincare together under one roof. From designer perfumes to professional cosmetics — discover our Beauty department with authentic brands and B2B pricing.",
  "Home promo tabs body delivery": "Order fragrance and makeup today and receive it quickly from our warehouse. Most Beauty orders ship within 24–48 hours across Romania, with traceable stock you can trust.",
  "Home promo tabs body quality": "Every perfume and makeup product is sourced from official distributors. We guarantee authenticity, full traceability and competitive B2B prices for corporate buyers.",
  "Home promo tabs link beauty": "Explore Beauty department",
  "Home promo tabs link fragrance": "Shop fragrance",
  "Home promo tabs link makeup": "Shop makeup",
  "Carousel hero fragrance eyebrow": "The fragrance edit",
  "Carousel hero fragrance title": "Signature Scents",
  "Carousel hero fragrance subtitle": "Rare essences and timeless perfumes for a presence that lingers",
  "Carousel hero fragrance cta": "Explore fragrance",
  "Home perfume spotlight title": "Signature scents for every moment",
  "Home perfume spotlight feature 1 title": "Iconic designer fragrances",
  "Home perfume spotlight feature 1 body": "Eau de parfum and extrait from houses such as Lalique, Parfums de Marly and Histoires de Parfums.",
  "Home perfume spotlight feature 2 title": "100% genuine products",
  "Home perfume spotlight feature 2 body": "Every bottle comes from official distribution channels, with traceable stock and B2B pricing.",
  "Home perfume spotlight feature 3 title": "Fast delivery across Romania",
  "Home perfume spotlight feature 3 body": "Order today and receive your fragrance quickly, with free shipping on eligible orders.",
  "Home brands marquee title": "Our brands",
  "Home brands marquee cta": "See all brands",
  "Carousel hero makeup eyebrow": "The beauty edit",
  "Carousel hero makeup title": "Art of Makeup",
  "Carousel hero makeup subtitle": "Editorial colour, refined textures and icons of modern beauty",
  "Carousel hero makeup cta": "Discover makeup",
  "Carousel hero hair eyebrow": "The hair edit",
  "Carousel hero hair title": "Salon Rituals",
  "Carousel hero hair subtitle": "Professional care and styling for hair that speaks of quiet luxury",
  "Carousel hero hair cta": "Explore hair care",
  "Volume": "Volume",
  "Tester": "Tester",
  "Sample": "Sample",
  "Damaged": "Damaged"
} as const;

export type I18nKey = keyof typeof en;
